jQuery.feature_import("js-person-registry",
    () => import("./person-registry-app"),
    mod => mod.feature_js_personAssignment
); 